'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconWindowDock, iconWindowDockTag } from '@ni/nimble-components/dist/esm/icons/window-dock';
import { wrap } from '../../utilities/react-wrapper';

export type { IconWindowDock };
export { iconWindowDockTag };
export const NimbleIconWindowDock = wrap(IconWindowDock);